import { render } from "./permission-list.vue?vue&type=template&id=2261a8f4"
import script from "./permission-list.vue?vue&type=script&lang=ts"
export * from "./permission-list.vue?vue&type=script&lang=ts"
script.render = render

export default script